<template>
    <div>
        <div class="table-main-actions-container">
            <div class="table-actions-container">
            <div class="row">
                <div class="sorting-container col-4">
                <el-button
                        type="info"
                        link
                        @click="refreshProjects"
                        >
                        <font-awesome-icon icon="fa-solid fa-compass-drafting"/> <span style="margin-left:5px;"> All Projects </span>
                        </el-button>
                </div>
                <div class="col-8 table-actions">
                <ul class="actions-list" v-if="projects.data">
                    <li><el-button :class="'add-btn danger'" type="danger" @click="openAddForm"><font-awesome-icon icon="fa-solid fa-plus"/> Add New</el-button></li>
                    <li >
                        <el-button
                        v-if="!isSearch"
                        type="info"
                        link
                        @click="isSearch = !isSearch"
                        >
                        <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Search
                        </el-button>
                        <el-input
                        v-if="isSearch"
                        v-model="searchValue"
                        style="max-width: 300px"
                        placeholder="Please input"
                        class="input-with-select"
                        >
                        <template #append>
                            <el-button style="width: 30px;" @click="searchProject">
                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                            </el-button>
                        </template>
                        </el-input>
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        <el-table :row-class-name="tableRowClassName" v-loading="isLoading" element-loading-text="Loading..." element-loading-background="rgba(255, 255, 255, 0.8)" :data="projects.data" style="width: 100%" :header-row-class-name="'table-header-style'" :header-cell-class-name="'table-header-cell-style'" :highlight-current-row="true" :cell-class-name="'custom-cell'">
            <el-table-column 
                label="ID" 
                prop="id" 

                
            />
            <el-table-column 
                label="Name" 
                
                
            >
            <template #default="scope">
                {{ scope.row.is_edit_active ? "" : scope.row.name }}
                <el-input
                    v-if="scope.row.is_edit_active"
                    v-model="Edited_model.name"
                    type="text"
                    placeholder="Project name"

                />
            </template>
            </el-table-column>
            
            <el-table-column 
                label="Description" 
                
                
            >
            <template #default="scope">
                <el-popover
                v-if="!scope.row.is_edit_active"
                placement="left-start"
                title="Description"
                :width="250"
                trigger="hover"
                :content="scope.row.description"
                >
                <template #reference>
                    {{scope.row.description}}
                    
                </template>
                </el-popover>
                <el-input
                    v-if="scope.row.is_edit_active"
                    v-model="Edited_model.description"
                    type="textarea"

                    placeholder="Project Desc"

                />
            </template>
            </el-table-column>
            
            <el-table-column 
                label="Rank" 

                
            >
            <template #default="scope">
                {{ scope.row.is_edit_active ? "" : scope.row.project_rank }}
                <el-input
                    v-if="scope.row.is_edit_active"
                    v-model="Edited_model.project_rank"
                    type="number"
                    :min="'0'"
                    clearable
                    placeholder="Rank"

                />
            </template>
            </el-table-column>
            
            <el-table-column 
                label="Photos" 
          
            >
            <template #default="scope">
                <el-image
                    style="width: 40px; height: 40px"
                    :src="'https://tapegypt.com/projects-photos/'+scope.row.photo_link"
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    
                    :initial-index="4"
                    fit="cover"
                />
            </template>
            </el-table-column>
            
            
            
            
            
            <el-table-column align="center" fixed="right" width="150">
                <template #header>
                    Actions
                </template>
                <template #default="scope">

                    <el-button size="small" @click="openEditForm(scope.$index)" :icon="Edit" 
                    circle v-if="!scope.row.is_edit_active"/>
                    
                    <el-button
                        size="small"
                        type="danger"
                        :icon="Delete" 
                        circle
                        @click="deleteProject(scope.row.id)"
                        v-if="!scope.row.is_edit_active"
                    />
                    <el-button type="success" :icon="Check" circle v-if="scope.row.is_edit_active" @click="EditProject(scope.$index)"/>
                    <el-button type="info" :icon="Close" circle @click="closeEdit(scope.$index)" v-if="scope.row.is_edit_active"/>
                    
                    
                    
                </template>
            </el-table-column>
        </el-table>

        <el-drawer
            
            
            v-model="isAdd"
            :title="'Add Project'"
            :direction="'rtl'"
            :modal-class="'add-project-modal-drawer'"
            :before-close="handleAddProjectClose"
        >
            <el-form
            ref="ruleFormRef"
            :model="add_model"
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            :label-position="'top'"
            :size="'default'"
            status-icon
            >

                <el-form-item prop="images">
                    <el-upload
                        ref="uploadRef"
                        class="upload-project-demo"
                        single
                        :auto-upload="false"
                        list-type="picture"
                        drag
                        :on-change="addImageToList"
                        :on-preview="handlePictureCardPreview"
                        :before-upload="beforeUpload"
                    >
                        <el-icon class="el-icon--upload"><upload-filled /></el-icon>

                        <template #tip>
                        <div class="el-upload__tip">
                            jpg/png file with a size less than 500kb
                        </div>
                        </template>
                    </el-upload>
                </el-form-item>

                <el-dialog v-model="dialogVisible">
                    <img w-full width="100%"  :src="dialogImageUrl" alt="Preview Image" />
                </el-dialog>

                <el-form-item prop="name" label="Name">
                    <el-input
                    v-model="add_model.name"
                    type="text"
                    placeholder="project name "
                    clearable
                  />
                </el-form-item>
                
                <el-form-item prop="project_rank" label="Project Rank">
                    <el-input


                    v-model="add_model.project_rank"
                    type="number"
                    min="0"
                    placeholder="Rank "
                    clearable
                  />
                </el-form-item>
                <el-form-item prop="developer_id" label="Developer ">
                    <el-select
                    v-model="add_model.developer_id"
                    filterable
                    clearable
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Developer"
                    
                    >
                    <el-option
                        v-for="dev in developersList"
                        :key="dev.id"
                        :label="dev.name"
                        :value="dev.id"
                    />
                    </el-select>
              </el-form-item>
                <el-form-item prop="description" label="Description">
                    <el-input
   
               
                    v-model="add_model.description"
                    type="textarea"
                    placeholder="Description "
                    :rows="5"
                    clearable
                  />
                </el-form-item>


            </el-form>
            <template #footer>
                <div style="flex: auto">
                    
                    <el-button v-loading.fullscreen.lock="isAddFormLoading" @click="handleAddProjectClose">cancel</el-button>
                    <el-button type="primary" @click="handleAddSubmit">Add Project</el-button>
                    
                </div>
            </template>
        </el-drawer>

        <div class="pagination-container">
        <el-pagination
          :page-size="projects.per_page"
          :pager-count="11"
          :size="'small'"
          layout="prev, pager, next"
          :total="projects.total"
          :background="true"
          :disabled="isDisabled"
          :current-page="page"
          @current-change="paginationChanged"
        />
      </div>
    </div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import { useStore } from 'vuex';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  Search ,
  View,
} from '@element-plus/icons-vue'
export default {
    name: 'Projects',
    setup(){
        const store = useStore();
        const page = ref();
        const isLoading = ref(false);
        const projects = ref([]);
        const Edited_model = ref({});
        const isSearch = ref(false);
        const isDisabled = ref(false);
        const isAdd = ref(false);
        const searchValue = ref('');
        const ruleFormRef = ref(null);
        const isAddFormLoading = ref(false);
        const uploadRef = ref(null);
        const dialogImageUrl = ref('');
        const dialogVisible = ref(false);
        const developersList = ref([]);
        const handlePictureCardPreview = (uploadFile) => {
            dialogImageUrl.value = uploadFile.url
            dialogVisible.value = true
        }
        const rules = reactive({
            name: [
                { required: true, message: '@Required', trigger: 'blur' },
                
            ],
            project_rank: [
                { required: true, message: '@Required', trigger: 'blur' },
            ],
            developer_id: [
                { required: true, message: '@Required', trigger: 'blur' },
            ],
        });
        const add_model = reactive({
            name:null,
            description:null,
            project_rank:null,
            photo_link:null,
            developer_id:null,
        });
        const searchProject = async () => {
            if(searchValue.value && searchValue.value != " " ){
                isLoading.value = true;
                const value = searchValue.value;
                const pageno = page.value;
                await store.dispatch('projects/searchProject' , { value:value , page:pageno})
                projects.value = store.getters['projects/getProjects'];
                isLoading.value = false;
            }
        };
        const openAddForm = () => {
            add_model.name , add_model.description , add_model.project_rank = null;
            isAdd.value = true;
        };
        const deleteProject = async (id) => {
            ElMessageBox.confirm(
            'Are you sure delete the Project. Continue?',
            'Warning',
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }
            )
            .then( async () => {
                isLoading.value = true;
                await store.dispatch('projects/deleteProject' , id);
                ElMessage({
                type: 'success',
                message: 'Delete successfull',
                })
                projects.value = store.getters['projects/getProjects'];
                isLoading.value = false;
            })
            .catch(() => {
                ElMessage({
                type: 'info',
                message: 'Delete canceled',
                })
            })
        };
        const paginationChanged = async (value) => {
            page.value= value;
            const pageno = page.value;
            isLoading.value = true;
            isDisabled.value = true;
            const svalue = searchValue.value;
            if(svalue){
                await store.dispatch('projects/searchProject' , { value:svalue , page:pageno});
            }
            else{
                await store.dispatch('projects/fetchProject' , pageno);
            }
            projects.value = store.getters['projects/getProjects'];
            isDisabled.value = false;
            isLoading.value = false;
        };
        onMounted(async () => {
            isLoading.value = true;
            await store.dispatch('projects/fetchProject' , page.value);
            developersList.value = store.getters['projects/getDevelopersList'];
            projects.value = store.getters['projects/getProjects'];
            isLoading.value = false;
        });
        const openEditForm = (row) => {
            //get backup of row
            Edited_model.value = {...projects.value.data[row]} ;
            //close all forms and open only selected row
            projects.value.data.map(project => project.is_edit_active = false);
            projects.value.data[row].is_edit_active = true;
            delete Edited_model.value.photo_link;
        }
        const closeEdit = (row) => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            ElMessage({
                type: 'info',
                message: 'Canceld.',
            })
            })
            .catch(() => {
            Edited_model.value = {};
            projects.value.data[row].is_edit_active = false;
            ElMessage({
                type: 'info',
                message:'Changes Discribed',
            })
            })
            
        };
        const EditProject = async (index) => {
            isLoading.value = true;

            await store.dispatch('projects/updateProject' , Edited_model.value);
            await store.dispatch('projects/fetchProject' , page.value);
            projects.value = store.getters['projects/getProjects'];
            //units.value.data[index] = Edited_model.value;
            projects.value.data[index].is_edit_active = false;
            isLoading.value = false;
        };
        const refreshProjects = async () => {
            page.value = 1;

            isLoading.value = true;
            searchValue.value = '';
            await store.dispatch('projects/fetchProject' , page.value);
            projects.value = store.getters['projects/getProjects'];
            isLoading.value = false;
        };
        const handleAddProjectClose = () => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            isAdd.value = false;
            resetForm();
            ElMessage({
                type: 'info',
                message: 'Changes Discribed',
            })
            })
            .catch(() => {
            
            ElMessage({
                type: 'info',
                message:'Canceld',
            })
            })
            
        };
        const handleAddSubmit = async () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;
                // Validate the form
                await form.validate(async (valid, fields) => {
                    if (valid) {
                        try {
                            isAddFormLoading.value = true;

                            

                            // Create a FormData object for submission
                            const formData = new FormData();

                            // Append all form fields (except 'images') to the FormData object
                            Object.keys(add_model).forEach((key) => {
                                
                                    formData.append(key, add_model[key]);
                                
                            });

                            console.log(formData);
                            // Send the form data to the store's action
                            await store.dispatch('projects/addNewProject', formData);
                            resetForm();
                            uploadRef.value.clearFiles();
                            
                            
                            isAdd.value = false;
                            ElMessage({
                                type: 'success',
                                message: 'Unit is Added Successfully',
                            })
                            
                        } catch (error) {
                            ElMessage({
                            type: 'error',
                            message: 'Something Went Wrong ...',
                            })
                        } finally {
                            isAddFormLoading.value = false;
                        }
                    } else {
                        console.log('Form is invalid:', fields);
                    }
                });
        };
        const resetForm = () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;

            // Reset the form fields
            form.resetFields();
        };
        const addImageToList = (file,fileList)=> {
            add_model.photo_link = file.raw;
            console.log(add_model);
        }
        return {
            developersList,
            dialogImageUrl,
            dialogVisible,
            isAdd,
            add_model,
            store,
            projects,
            page,
            isDisabled,
            isLoading,
            Edited_model,
            isSearch,
            searchValue,
            isAddFormLoading,
            ArrowRight,
            CaretBottom,
            CaretTop,
            Check,
            Warning,
            Delete,
            Edit,
            Close,
            Search ,
            View,
            uploadRef,
            ruleFormRef,
            resetForm,
            rules,
            openEditForm,
            closeEdit,
            EditProject,
            refreshProjects,
            paginationChanged,
            searchProject,
            deleteProject,
            openAddForm,
            handleAddProjectClose,
            handleAddSubmit,
            addImageToList,
            handlePictureCardPreview,
        }
    }
}
</script>

<style lang="scss">
.el-drawer{
    .upload-project-demo{
        width: 100%;
    }
  ::-webkit-scrollbar {
    width: 4px;
    transition: 0.2s ease-in-out;
  }
  /* ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    transition: 0.2s ease-in-out;
  }
  &:hover{
    ::-webkit-scrollbar-thumb {
      transition: 0.2s ease-in-out;
      background: #034750;
    }
  } */
}
.add-project-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 23% !important;
    }
  }
}
@import '../assets/styles/table.scss';


.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-list .el-upload-list__item {
  cursor: move;
}

</style>